// 1. loginLogService.ts
import { BaseService } from "./baseService";
import { LoginLogDto } from "../types/loginLog"; // Βεβαιώσου ότι το path είναι σωστό

class LoginLogService extends BaseService<LoginLogDto> {
  constructor() {
    super("/LoginLog");
  }
}

export const loginLogService = new LoginLogService();